import { render, staticRenderFns } from "./ExpandData.vue?vue&type=template&id=225e4a0a&scoped=true"
import script from "./ExpandData.vue?vue&type=script&lang=js"
export * from "./ExpandData.vue?vue&type=script&lang=js"
import style0 from "./ExpandData.vue?vue&type=style&index=0&id=225e4a0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225e4a0a",
  null
  
)

export default component.exports